import { render } from "./ImagePreview.vue?vue&type=template&id=607bb7f6&scoped=true"
import script from "./ImagePreview.vue?vue&type=script&lang=js"
export * from "./ImagePreview.vue?vue&type=script&lang=js"

import "./ImagePreview.vue?vue&type=style&index=0&id=607bb7f6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-607bb7f6"

export default script